import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslationService } from 'src/app/Services/translation.service';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-aboutus',
  templateUrl: './aboutus.component.html',
  styleUrls: ['./aboutus.component.css'],
})
export class AboutusComponent implements OnInit {
  selectedLang: string = 'bg';
  constructor(private translationService: TranslationService) {}

  ngOnInit(): void {
    this.selectedLang = this.translationService.getCurrentLanguage().code;
  }
}
